import React from 'react';

import { FormattedMessage } from 'react-intl';

const SupportLink = props =>
  <a rel="noopener" target="_blank" href="http://help.depop.com/" {...props}>
    <FormattedMessage
      id="app.supportLabel"
      description="Support Label"
      defaultMessage="Support"
    />
  </a>;

export default SupportLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/SupportLink.js